<div class="list-for-order-type">
    <div class="inner list-for-order-type__inner">

        <ng-container *ngIf="orderTypes?.isDownloading === true">
            <div class="item list-for-order-type__item" *ngFor="let item of emptyPlaceholders; trackBy: trackBy">
                <shared-tile-for-order-type></shared-tile-for-order-type>
            </div>
        </ng-container>

        <ng-container *ngIf="orderTypes?.isDownloading === false">

            <ng-container *ngIf="!isEmpty">
                <ng-container *ngFor="let orderType of orderTypes?.data | limit:limit; trackBy: trackBy">
                    <div class="item list-for-order-type__item">
                        <shared-tile-for-order-type [orderType]="orderType">
                        </shared-tile-for-order-type>
                    </div>
                </ng-container>
            </ng-container>

        </ng-container>

    </div>
</div>
